import * as constants from '../constants/location.constants';
import { AppDispatch } from '../store';

export const setLocation = (payload: any) => (dispatch: AppDispatch) => {
  dispatch({ type: constants.SET_LOCATION, payload });
};
